import { canadianSchoolsData } from '../data/canadianSchoolsData';

// Interface for Canadian AI draft school data
export interface CanadianAIDraftSchool {
  id: string;
  name: string;
  fileName: string;
}

export class CanadianAIDraftService {
  // All Canadian AI draft schools have been reviewed and added to the database
  private static readonly CANADIAN_AI_DRAFT_SCHOOLS: string[] = [];

  static async getCanadianAIDraftSchools(): Promise<CanadianAIDraftSchool[]> {
    // Sample data from actual Canadian university files for demonstration
    // In a real implementation, this would read from the schoolsToBeReviewedCanada folder
    const sampleCanadianUniversityData: Record<string, any> = {};

    const canadianAIDraftSchools: CanadianAIDraftSchool[] = [];

    for (const fileName of this.CANADIAN_AI_DRAFT_SCHOOLS) {
      // Extract school name from filename
      const schoolName = fileName
        .replace('-data.json', '')
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      // Get data for this school
      const schoolData = sampleCanadianUniversityData[fileName as keyof typeof sampleCanadianUniversityData];
      
      if (schoolData) {
        canadianAIDraftSchools.push({
          id: fileName,
          name: schoolData.SchoolName || schoolName,
          fileName: fileName
        });
      }
    }

    return canadianAIDraftSchools;
  }

  static async getCanadianAIDraftSchoolData(fileName: string): Promise<any> {
    try {
      // Use the imported data from the separate data file
      return canadianSchoolsData[fileName] || null;
    } catch (error) {
      console.error('Error loading Canadian AI draft school data:', error);
      return null;
    }
  }

  static convertCanadianAIDraftToFormData(aiDraftData: any): any {
    return {
      name: aiDraftData.SchoolName || '',
      type: aiDraftData.SchoolType || 'College',
      city: aiDraftData.SchoolCity || '',
      province: aiDraftData.SchoolProvinceState || '',
      website: aiDraftData.SchoolWebsite || '',
      image: aiDraftData.SchoolProfileImageURL || '',
      description: aiDraftData.SchoolDescription || '',
      acceptanceRate: parseFloat(aiDraftData.acceptanceRate) || 0,
      enrollment: parseInt(aiDraftData.SchoolFTUGCount) || 0,
      roomAndBoardLow: parseFloat(aiDraftData.SchoolRoomAndBoardLow) || 0,
      roomAndBoardHigh: parseFloat(aiDraftData.SchoolRoomAndBoardHigh) || 0,
      resultsImage: aiDraftData.SchoolResultsImageURL || '',
      feedIcon: '',
      athleticsWebsite: aiDraftData.AthleticsWebsite || '',
      admissionsMinimum: aiDraftData.SchoolAdmissionsMin || '',
      athleticsNickname: aiDraftData.AthleticsNickname || '',
      primaryLanguage: aiDraftData.SchoolPrimaryLanguage || '',
      SchoolPhone: aiDraftData.SchoolPhone || '',
      SchoolTwitterURL: aiDraftData.SchoolTwitterURL || '',
      SchoolInstagramURL: aiDraftData.SchoolInstagramURL || '',
      SchoolWikiURL: aiDraftData.SchoolWikiURL || '',
      SchoolYoutubeURL: aiDraftData.SchoolYoutubeURL || '',
      SchoolResultsImageURL: aiDraftData.SchoolResultsImageURL || '',
      SchoolLocationLatitude: aiDraftData.SchoolLocationLatitude || '',
      SchoolLocationLongitude: aiDraftData.SchoolLocationLongitude || '',
      SchoolAdmissionsACT: '',
      SchoolAdmissionsGPA: '',
      SchoolAdmissionsSAT: '',
      programs: [],
      athletics: [],
      events: [],
      scholarships: [],
      admissionRequirements: aiDraftData.SchoolBasicRequirements || '',
      socialMedia: []
    };
  }
}
